export const catalogTranslations = {
    en: {
      titles: {
        head1: "Catalog of enterprises",
        head2: "Member News",
        head3: "Events in Photos",
      },
      
      about_us: "About Us"
    },
    fr: {
      about_us: "À propos de nous",
    
      titles:{head1:"Annuaire des entreprises",head2:"Actualités des membres",head3:"Evènements en photos",},
  
    }
  };
